var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKseLogoBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Katalon Studio Enterprise") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Get-Started",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3-Invite-users-to-your-organization",
    transform: "translate(-367.000000, -541.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-kse",
    transform: "translate(367.000000, 541.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-41-Copy-42",
    fill: "#9DCC3D",
    points: "9.9475983e-13 35 13.1243676 35 35 0 4.97379915e-13 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-41-Copy-11",
    fill: "#67B340",
    transform: "translate(21.829199, 22.968750) scale(-1, 1) translate(-21.829199, -22.968750) ",
    points: "8.65839844 35 30.5340308 35 35 25.6771484 22.8601313 10.9375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.05,8.02083333 L25.2791667,8.02083333 C25.8314514,8.02083333 26.2791667,8.46854858 26.2791667,9.02083333 L26.2791667,25.25 C26.2791667,25.8022847 25.8314514,26.25 25.2791667,26.25 L9.05,26.25 C8.49771525,26.25 8.05,25.8022847 8.05,25.25 L8.05,9.02083333 C8.05,8.46854858 8.49771525,8.02083333 9.05,8.02083333 Z",
    id: "Rectangle-Copy-14",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6669809,12.3958333 C15.8440226,12.3958333 16.8044821,13.6768018 16.8044821,13.6768018 C16.0911498,14.845045 15.7344837,15.4291667 15.7344837,15.4291667 C15.6447017,15.3036657 15.5339442,15.1772768 15.4022112,15.05 C15.4022112,15.05 14.8067263,14.4453829 13.9231035,14.4453829 C13.3468277,14.4453829 12.7731132,14.6712773 12.7731132,15.213964 C12.7731132,16.430884 17.1246353,15.7903998 17.1246353,18.9287725 C17.1246353,20.5299831 15.779992,21.875 13.5389197,21.875 C11.82216,21.875 10.719492,21.06784 10.2375,20.6233146 C10.2375,20.6233146 10.5962209,20.0371178 11.3136627,18.8647241 C11.3136627,18.8647241 12.1302456,19.8254505 13.2827971,19.8254505 C14.0985057,19.8254505 14.7388538,19.5643528 14.7388538,18.9287725 C14.7388538,17.5125133 10.2733572,18.3980406 10.2733572,15.1499155 C10.2733572,13.7408502 11.6180005,12.3958333 13.6669809,12.3958333 Z M23.3625,12.8697917 L23.3625,14.6826823 L19.7377256,14.6826823 L19.7377256,16.230889 L22.5096119,16.230889 L22.5096119,18.0605375 L19.7377256,18.0605375 L19.7377256,19.6414714 L23.3625,19.6414714 L23.3625,21.4010417 L17.8187274,21.4010417 L17.8187274,12.8697917 L23.3625,12.8697917 Z",
    id: "Combined-Shape",
    fill: "#67B340",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKseLogoBig);
export default __webpack_public_path__ + "static/media/KSE_logo_big.e08034f60ba2aefe44bdedfd5897749e.svg";
export { ForwardRef as ReactComponent };